import script from "./SelectOptionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOptionInfo.vue?vue&type=script&setup=true&lang=js"

import "./SelectOptionInfo.vue?vue&type=style&index=0&id=3f1fd252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1fd252"]])

export default __exports__